import { render, staticRenderFns } from "./MendingUpgradeButton.vue?vue&type=template&id=4d6a9123&scoped=true&"
import script from "./MendingUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./MendingUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6a9123",
  null
  
)

export default component.exports